__turbopack_context__.v({
  "button": "CheckoutButton-module-scss-module__RYvtjW__button",
});
